import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

// Safe, non-admin read of just the HubSpot outage boolean, used by the app-wide banner so
// it is visible to all authenticated users (getSystemFlags is admin-only).
export const getHubspotDisabled = api(async function isHubspotDisabled() {
    return query(
        gql`
            query isHubspotDisabled {
                isHubspotDisabled
            }
        `,
        {},
        { returns: "isHubspotDisabled" }
    )
})
